import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.InstitutionsInstitutionTypeEnumSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    institutionsInstitutionTypeEnumList: { items: data, total },
  } = await sdk.getListinstitutionInstitutionTypeEnum(
    filterSortPage({
      sort,
      pagination,
      filter,
    })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { institutionsInstitutionTypeEnum: data } =
    await sdk.getOneinstitutionInstitutionTypeEnum({
      id,
    });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { institutionsInstitutionTypeEnumMany: data } =
    await sdk.getManyinstitutionInstitutionTypeEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const institutionInstitutionTypeEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
